import Vue from 'vue'
import vuex from 'vuex'
// import vuexAlong from 'vuex-along'
Vue.use(vuex)
import globalStore from './modules/global'
import sysStore from './modules/sys'
import wechatStore from './modules/wechat'
import themeStore from './modules/theme'
import tagStore from './modules/tag'
const store = new vuex.Store({
  // plugins: [vuexAlong],
  modules: {
    globalStore,
    sysStore,
    wechatStore,
    themeStore,
    tagStore
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/storeAll.js